export const rankColors = [
    {
        back: '#dbdcde',
        color: '#dbdcde',
        gradient: 'rgba(209, 215, 226, 1)'
    },
    {
        back: '#DFF5EA',
        color: 'rgba(173, 154, 145, 1)',
        gradient: 'linear-gradient(90deg, rgba(42, 185, 116, 1) 0%, rgba(147, 224, 187, 1) 100%)',
        gradientColor1: 'rgba(201, 166, 150, 1)',
        gradientColor2: 'rgba(76, 55, 45, 1)'
    },
    {
        back: '#E1F7FC',
        color: 'rgba(220, 169, 126, 1)',
        gradient: 'linear-gradient(90deg, rgba(54, 202, 235, 1) 0%, rgba(54, 202, 235, 1) 100%)',
        gradientColor1: 'rgba(214, 160, 115, 1)',
        gradientColor2: 'rgba(72, 41, 16, 1)'
    },
    {
        back: '#E3E7F7',
        color: 'rgba(210, 181, 133, 1)',
        gradient: 'linear-gradient(108.49deg, rgba(107, 135, 239, 1) 0%, rgba(67, 95, 197, 1) 100%)',
        gradientColor1: 'rgba(225, 185, 120, 1)',
        gradientColor2: 'rgba(96, 68, 23, 1)'
    },
    {
        back: '#F1E3F6',
        color: 'rgba(206, 185, 112, 1)',
        gradient: 'linear-gradient(90deg, rgba(161, 46, 225, 1) 0%, rgba(220, 157, 255, 1) 100%)',
        gradientColor1: 'rgba(217, 190, 95, 1)',
        gradientColor2: 'rgba(124, 97, 37, 1)'
    },
    {
        back: '#F9E4E8',
        color: 'rgba(180, 190, 113, 1)',
        gradient: 'linear-gradient(90deg, rgba(217, 71, 99, 1) 0%, rgba(217, 71, 99, 1) 100%)',
        gradientColor1: 'rgba(206, 218, 128, 1)',
        gradientColor2: 'rgba(63, 72, 7, 1)'
    },
    {
        back: '#FEEEE1',
        color: 'rgba(205, 160, 150, 1)',
        gradient: 'linear-gradient(90deg, rgba(255, 228, 118, 1) 0%, rgba(255, 204, 0, 1) 100%)',
        gradientColor1: 'rgba(99, 60, 51, 1)',
        gradientColor2: 'rgba(99, 60, 51, 1)'
    },
    {
        back: '#FEF3E0',
        color: 'rgba(190, 190, 190, 1)',
        gradient: 'linear-gradient(90deg, rgba(250, 176, 49, 1) 0%, rgba(250, 176, 49, 1) 100%)',
        gradientColor1: 'rgba(197, 197, 197, 1)',
        gradientColor2: 'rgba(85, 85, 85, 1)'
    },
    {
        back: '#FEF3E0',
        color: 'rgba(237, 207, 137, 1)',
        gradient: 'linear-gradient(90deg, rgba(250, 176, 49, 1) 0%, rgba(250, 176, 49, 1) 100%)',
        gradientColor1: 'rgba(245, 225, 149, 1)',
        gradientColor2: 'rgba(207, 133, 66, 1)'
    },
    {
        back: '#FEF3E0',
        color: 'rgba(159, 211, 238, 1)',
        gradient: 'linear-gradient(90deg, rgba(250, 176, 49, 1) 0%, rgba(250, 176, 49, 1) 100%)',
        gradientColor1: 'rgba(156, 214, 237, 1)',
        gradientColor2: 'rgba(57, 80, 181, 1)'
    },
    {
        back: '#FEF3E0',
        color: 'rgba(219, 196, 241, 1)',
        gradient: 'linear-gradient(90deg, rgba(250, 176, 49, 1) 0%, rgba(250, 176, 49, 1) 100%)',
        gradientColor1: 'rgba(172, 136, 228, 1)',
        gradientColor2: 'rgba(56, 28, 178, 1)'
    },
    {
        back: '#FEF3E0',
        color: 'rgba(242, 160, 143, 1)',
        gradient: 'linear-gradient(90deg, rgba(250, 176, 49, 1) 0%, rgba(250, 176, 49, 1) 100%)',
        gradientColor1: 'rgba(242, 227, 126, 1)',
        gradientColor2: 'rgba(234, 106, 72, 1)'
    }
];
